import { Backdrop, Box, CircularProgress, Grid, IconButton, Paper, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import SaveIcon from "@mui/icons-material/Save";
import InputField from '../../formElements/InputField';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../Modal';
import { useChangePassword } from './useChangePassword';
import { invokeIfCallable } from '../../../library/shared';
import { LoadingButton } from '@mui/lab';
const ChangePasswordModal = ({ open, onClose }) => {
    let { changePassword, data, handleChange, loading, backDrop } = useChangePassword({ open, onClose })
    const inputRef = useRef(null)
    useEffect(() => {
        if (open)
            invokeIfCallable(() => inputRef?.current?.focus(), 100)
        return () => {
        }
    }, [open, inputRef])

    useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault(); 
        changePassword();
      }
    };

    window.addEventListener("keydown", controlAndS);

    return () => {
      window.removeEventListener("keydown", controlAndS);
    };
  }, [data]);

    return (
        <Modal open={open} onClose={() => { onClose() }}>
            <Paper component="form" onSubmit={(e) => { e.preventDefault(); changePassword() }} noValidate>
                <input
                    type="hidden"
                    name="username"
                    autocomplete="username"
                    value={localStorage?.getItem('email')}
                />
                <Modal.Header >
                    <Box
                        sx={{
                            backgroundColor: "primary.main",
                            padding: "5px 10px",
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                Change Password
                                <IconButton aria-label="delete" className='btn' onClick={() => invokeIfCallable(onClose)}>
                                    <CloseIcon sx={{ color: "#fff" }} />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Modal.Header >
                <Modal.Body>
                    <Box
                        sx={{
                            padding: { sm: "7px 20px", xs: "7px 8px" },
                            borderRadius: "0 7px",
                            transition: "all 2s ease-in-out",
                            width: { xs: "95%", sm: '450px' },
                            // minWidth: '350px'
                        }}
                    >
                        <Grid container rowGap={1} sx={{ marginTop: '10px' }}>
                            <Grid item xs={12} >
                                <InputField
                                    name="currentPassword"
                                    placeholder="Current Password"
                                    size="small"
                                    required={true}
                                    type="password"
                                    state={data}
                                    value={data.currentPassword}
                                    inputRef={inputRef}
                                    onChange={(e) => handleChange(e, 'Current Password')} />
                            </Grid>
                            <Grid item xs={12} >
                                <InputField
                                    name="newPassword"
                                    placeholder="New Password"
                                    size="small"
                                    required={true}
                                    type="password"
                                    state={data}
                                    value={data.newPassword}
                                    onChange={(e) => handleChange(e, 'New Password')} />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', m: 0 }}>
                                    {data?.newPassword.length > 0 &&
                                        (
                                            <>
                                                <Box sx={{
                                                    display: 'flex',
                                                    marginTop: '-10px',
                                                    marginLeft: '10px',
                                                    color: (/[a-z]/.test(data.newPassword) && /[A-Z]/.test(data.newPassword) ? '#0DB66E' : '#F22E07'),

                                                }}>

                                                    {/[a-z]/.test(data.newPassword) && /[A-Z]/.test(data.newPassword) ? <DoneIcon style={{ fontSize: '18px', }} /> : <CloseIcon style={{ fontSize: '18px', }} />}
                                                    <Typography sx={{
                                                        fontSize: '12px', color: (/[a-z]/.test(data.newPassword) && /[A-Z]/.test(data.newPassword) ? '#0DB66E' : '#F22E07'),
                                                    }}>Must Contain Atleast 1 Uppercase & lowercase characters</Typography>
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    marginLeft: '10px',
                                                    color: (/\d/.test(data.newPassword) ? '#0DB66E' : '#F22E07')
                                                }}>
                                                    {/\d/.test(data.newPassword) ? <DoneIcon style={{ fontSize: '18px', }} /> : <CloseIcon style={{ fontSize: '18px', }} />}
                                                    <Typography sx={{
                                                        fontSize: '12px',
                                                        color: (/\d/.test(data.newPassword) ? '#0DB66E' : '#F22E07')
                                                    }} >Must Contain Atleast 1 Number</Typography>
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    marginLeft: '10px',
                                                    color: (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(data.newPassword) ? '#0DB66E' : '#F22E07')
                                                }}>
                                                    {/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(data.newPassword) ? <DoneIcon style={{ fontSize: '18px', }} /> : <CloseIcon style={{ fontSize: '18px', }} />}
                                                    <Typography sx={{
                                                        fontSize: '12px',
                                                        color: (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(data.newPassword) ? '#0DB66E' : '#F22E07')
                                                    }}>Must Contain Atleast 1 special character</Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    marginLeft: '10px',
                                                    color: (!/\s/g.test(data.newPassword) && data.newPassword.length > 1 ? '#0DB66E' : '#F22E07')
                                                }}>
                                                    {!/\s/g.test(data.newPassword) && data.newPassword.length > 1 ? <DoneIcon style={{ fontSize: '18px', }} /> : <CloseIcon style={{ fontSize: '18px', }} />}
                                                    <Typography sx={{
                                                        fontSize: '12px',
                                                        color: (!/\s/g.test(data.newPassword) && data.newPassword.length > 1 ? '#0DB66E' : '#F22E07')
                                                    }} >Whitespace not allowed</Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    marginLeft: '10px',
                                                    color: (data.newPassword.length >= 8 ? '#0DB66E' : '#F22E07')
                                                }}>
                                                    {data.newPassword.length >= 8 ? <DoneIcon style={{ fontSize: '18px', }} /> : <CloseIcon style={{ fontSize: '18px', }} />}
                                                    <Typography sx={{
                                                        fontSize: '12px',
                                                        color: (data.newPassword.length >= 8 ? '#0DB66E' : '#F22E07')
                                                    }}>Must be Atleast 8 characters</Typography>
                                                </Box>
                                            </>
                                        )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} >
                                <InputField
                                    name="confirmPassword"
                                    placeholder="Confirm Password"
                                    size="small"
                                    required={true}
                                    type="password"
                                    state={data}
                                    value={data.confirmPassword}
                                    onChange={(e) => handleChange(e, 'Confirm Password')} />
                            </Grid>
                        </Grid>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Box sx={{ display: 'flex', justifyContent: 'end', padding: '10px' }}>
                        <LoadingButton loading={loading}
                            loadingPosition="start"
                            color="primary"
                            startIcon={<SaveIcon />}
                            variant="contained" onClick={changePassword} className='btn' >Change Password</LoadingButton>
                    </Box>
                </Modal.Footer>
            </Paper>
        </Modal >
    )
}

export default ChangePasswordModal
